import {Component, Input, OnInit} from '@angular/core';

const MESSAGE_STATUS_IMAGES = {
  send: 'assets/svg/grey_tick.svg',
  deliver: 'assets/svg/double_grey_tick.svg',
  read: 'assets/svg/double_blue_tick.svg',
  error: 'assets/svg/triangle-filled.svg',
};

@Component({
    selector: 'app-read-receipt',
    templateUrl: './read-receipt.component.html',
    styleUrls: ['./read-receipt.component.scss']
})
export class ReadReceiptComponent implements OnInit {

  @Input() messageStatus: string;
  state = MESSAGE_STATUS_IMAGES;

  constructor() { }

  ngOnInit(): void { }

}
